import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import RewardForm from './RewardForm';
// import { initialValues  } from './initialValues-testing';
import { showRewardApi, updateRewardApi, clearEditedReward } from './rewardSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function RewardUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.reward);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateRewardApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showRewardApi({ navigate, id }));

        return () => dispatch(clearEditedReward());
    }, []);

    return (
        <RewardForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default RewardUpdate;
